import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AddressCreatePage } from './address-create';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		AddressCreatePage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(AddressCreatePage),
	],
})
export class AddressCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/address-create/address-create.module.ts